import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { headlineStyles } from "../styles";
import React from "react";
import { CSS_MQ } from "../../../styles/breakpoints";
import { ContentContainer } from "../../../components/_shared-components/arrangement/Container";
import { fontStyles } from "../../../styles/fonts";
import { SparePartsProductListingPageTranslation } from "@swo/storefront";
import { T } from "../../../components/T";

export const ShowSparePartsHeadline: ReactTFC<{
  headline: React.ReactNode;
  translations: SparePartsProductListingPageTranslation;
}> = props => {
  const subheadline = props.translations.sparePartsFinder;

  return (
    <ContentContainer>
      <div
        css={css`
          text-align: center;
          margin-bottom: 30px;

          ${CSS_MQ.atLeastLg} {
            margin-bottom: 50px;
          }
        `}
      >
        <span
          css={[
            fontStyles.headline5,
            css`
              display: block;
              margin-bottom: 5px;
            `,
          ]}
        >
          <T>{subheadline}</T>
        </span>
        <span
          css={[
            headlineStyles,
            css`
              text-transform: uppercase;
            `,
          ]}
        >
          {props.headline}
        </span>
      </div>
    </ContentContainer>
  );
};
